import Vue from 'vue'
import VueRouter from 'vue-router'
import Closed from '../views/Closed.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Closed,
    meta: {
      title: 'codejam(2023).',
      metaTags: [
        {
          name: 'description',
          content: 'have a nice coding~'
        }
      ]
    }
  },
  {
    path: '/challenge',
    name: 'Challenge',
    component: () => import('../views/Challenge.vue'),
    meta: {
      title: 'challenge / codejam(2023).',
      metaTags: [
        {
          name: 'description',
          content: 'code fast. break cases.'
        }
      ]
    }
  },
  {
    path: '/score',
    name: 'Scoreboard',
    component: () => import('../views/Score.vue'),
    meta: {
      title: 'scoreboard / codejam(2023).',
      metaTags: [
        {
          name: 'description',
          content: 'code fast. break cases.'
        }
      ]
    }
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: () => import('../views/Signin.vue'),
    meta: {
      title: 'Sign In / codejam(2023).',
      metaTags: [
        {
          name: 'description',
          content: 'ssSSttt.'
        }
      ]
    }
  },
  // {
  //   path: '/signup',
  //   name: 'SignUn',
  //   component: () => import('../views/Signup.vue'),
  //   meta: {
  //     title: 'Sign Un / codejam(2023).',
  //     metaTags: [
  //       {
  //         name: 'description',
  //         content: 'ssSSttt.'
  //       }
  //     ]
  //   }
  // },
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // smooth scroll to top when page change dengan menggunakan .scroll
  // .scroll(posisi x, posisi y, behavior)
  window.scroll({
    top: to,
    left: 0,
    behavior: 'smooth'
  })
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if (previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  if (!nearestWithMeta) return next();

  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
    .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router
